export default __webpack_public_path__ + "static/media/ashish.fa8dbf13.jpg";